import React from 'react';
import {useLocation} from 'react-router-dom';

const NotFound = () => {
    const location = useLocation().pathname
    return (
        <div style={{
            maxWidth: "600px",
            margin: "0 auto",
            marginTop: "20px",
        }}>
            <h1>Page not found: {location}</h1>
            <p>
                The page you are looking for does not exist. Please check the URL or go
                <a href="#" onClick={() => history.go(-1)}> back</a>.
            </p>
        </div>
    );
}

export default NotFound;